import './Services.css';

const SERVICES = [
  { icon: '📷', title: 'Kameralı Su Kaçağı Tespiti', desc: 'Özel kamera sistemlerimizle boru içini görüntüleyerek kaçak noktasını duvar yıkmadan tespit ediyoruz.' },
  { icon: '💧', title: 'Su Kaçağı Tespiti',           desc: 'Modern ekipmanlarla gizli su kaçaklarını hızla bulup kalıcı çözüm üretiyoruz.' },
  { icon: '🔩', title: 'Tıkanıklık Açma',             desc: 'Lavabo, klozet ve pis su borularındaki her türlü tıkanıklığı profesyonelce açıyoruz.' },
  { icon: '🚰', title: 'Tıkalı Gider Açma',           desc: 'Tıkalı gider ve pis su hatlarında hızlı müdahale ile akışı yeniden sağlıyoruz.' },
  { icon: '🌊', title: 'Tıkalı Gider Yıkama',         desc: 'Yüksek basınçlı su ile gider hatlarını temizleyerek uzun vadeli tıkanıklık sorunlarını çözüyoruz.' },
  { icon: '🔧', title: 'Tesisat Tadilat',             desc: 'Eski ve hasarlı tesisat hatlarının yenilenmesi, tadilatı ve modernizasyonu için komple çözümler.' },
];

export function SectionHeader({ tag, title, titleAccent, sub, center }) {
  return (
    <div className={`section-header${center ? ' section-header--center' : ''}`}>
      {tag && <span className="section-header__tag">{tag}</span>}
      <h2 className="section-header__title">
        {title}{titleAccent && <span> {titleAccent}</span>}
      </h2>
      {sub && <p className="section-header__sub">{sub}</p>}
    </div>
  );
}

function Services() {
  return (
    <section id="hizmetler" className="services">
      <div className="services__inner">
        <SectionHeader
          tag="Hizmetlerimiz"
          title="Ne"
          titleAccent="Yapıyoruz?"
          sub="Tüm tesisat ihtiyaçlarınız için kapsamlı ve güvenilir çözümler sunuyoruz."
          center
        />
        <div className="services__grid">
          {SERVICES.map((s, i) => (
            <div key={s.title} className="service-card">
              <div className="service-card__num">0{i + 1}</div>
              <div className="service-card__icon">{s.icon}</div>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
